import CountdownTimer from 'countdown';

export default class Countdown{
    static get selectors() {
        return {
            main: '.b-countdown',
            day: '.b-countdown__number_day',
            hour: '.b-countdown__number_hour',
            minute: '.b-countdown__number_minute',
            second: '.b-countdown__number_second',
        }
    }

    static init($context = $(document), options = {}){
        $(Countdown.selectors.main, $context).each((i, elem) => {
            const $elem = $(elem);

            if(!$elem.hasClass('js-init')) return;
            if(!$elem.data('date-end')) return;
            if($elem.data('block-api')) return;

            new Countdown($elem, options);
        })
    }

    constructor($elem, options) {
        this.params = $.extend({
            selectors: Countdown.selectors,
        }, options);

        this.elems = {
            $main: $elem,
            $day: $elem.find(this.params.selectors.day),
            $hour: $elem.find(this.params.selectors.hour),
            $minute: $elem.find(this.params.selectors.minute),
            $second: $elem.find(this.params.selectors.second)
        };

        this.dateEnd = this.elems.$main.data('date-end');

        this.initCountdown();

        this.initBlockApi();
    }

    initBlockApi(){
        this.elems.$main.data('block-api', this);
    }

    initCountdown() {
        this.renderTime(CountdownTimer(new Date(this.dateEnd)));

        setInterval(() => {
            const timeOver = CountdownTimer(new Date(this.dateEnd));
            this.renderTime(timeOver);
        }, 1000)
    }

    renderTime(timestamp){
        this.elems.$day.text(timestamp.days);
        this.elems.$hour.text(timestamp.hours);
        this.elems.$minute.text(timestamp.minutes);
        this.elems.$second.text(timestamp.seconds);
    }

}
